export default class TranslationListItemRequest {
    constructor(
        public languageId: number,
        public value: string,
        public lookupTypeId: number | null,
        public objectId?: number,
    ) {}
}
